import api from './api';

export default {
    index(search=false,sort=false,page=1){
        return api.get(`${process.env.VUE_APP_URL}/organizations` , {params: {search:search , sort:sort , page:page}});
    },
    create(params){
        return api.post(`${process.env.VUE_APP_URL}/organizations` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/organizations/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/organizations/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/organizations/${id}`);
    },
}